import React from "react";
import { useHistory } from "react-router-dom";
import Homepage from "./Homepage";
import RoleSelectModal from "markup/Element/RoleSelectModal";

/**
 * /ilan-ver renders the homepage with the RoleSelect modal popped over it.
 * Closing the modal navigates back to /, so the URL stays meaningful and
 * shareable while the user keeps the homepage as their visual context.
 */
function IlanVerLanding(props) {
  const history = useHistory();
  const close = () => history.push("/");

  return (
    <>
      <Homepage {...props} />
      <RoleSelectModal open onClose={close} />
    </>
  );
}

export default IlanVerLanding;
